import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const AndroidSend = ({
  height = 28,
  width = 28,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 28 28" {...props}>
    <g clipPath="url(#androidSend_6286_118488)">
      <path
        d="M9.85852 22.0438L21.0876 10.0068L4.62915 10.3242L6.6562 14.8848L17.1304 11.7725L7.81828 17.4891L9.85852 22.0438Z"
        fill={getColor(color, isColorInherited)}
      />
    </g>
    <defs>
      <clipPath id="androidSend_6286_118488">
        <rect
          width="21"
          height="21"
          fill={getColor(color, isColorInherited)}
          transform="translate(0 8.55664) rotate(-24.0468)"
        />
      </clipPath>
    </defs>
  </SvgIcon>
);
